import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Modal,
  Slide,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Search from "@mui/icons-material/Search";
import Controls from "../../Component/controls/Controls";
import { useLocation, useNavigate } from "react-router";
import { addUserMargin, deleteCompany } from "../../state/action/buyerAction";
import {
  buyerDetails,
  CompanyAssign,
  getCompany,
  taxStatusChange,
} from "../../state/action/userAction";
import { useForm } from "../../Utils/useForm";
import Notification from "../../Utils/Notification";
import { useSnackbar } from "notistack";
import "./buyer.css";

const initialValues = {
  userName: "",
  comapnyName: "",
  email: "",
  mobile: "",
  margin: "",
  userMarginType: "",
  userMargin: "",
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  border: "0",
  outline: "0",
  bgcolor: "#fff",
  borderRadius: "16px",
  p: 3,
  boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const InfoField = ({ label, value }) => (
  <Box>
    <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", mb: 0.5 }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: "14px", fontWeight: 500, color: "#111827" }}>
      {value || "—"}
    </Typography>
  </Box>
);

const SectionCard = ({ icon, title, children, action }) => (
  <Card sx={{ borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #e5e7eb", mb: 3, backgroundColor: "#fff" }}>
    <CardContent sx={{ p: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2.5}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Box sx={{ bgcolor: "rgb(79,70,229,0.1)", borderRadius: "8px", p: 0.8, display: "flex" }}>
            {React.cloneElement(icon, { sx: { fontSize: 18, color: "rgb(79,70,229)" } })}
          </Box>
          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#111827" }}>{title}</Typography>
        </Stack>
        {action}
      </Stack>
      {children}
    </CardContent>
  </Card>
);

const tdsList = [
  { id: 1, title: "TCS" },
  { id: 2, title: "TDS" },
];

function BuyerDetail() {
  const [buyer, setBuyer] = useState({});
  const [company, setCompany] = useState([]);
  const [category, setCategory] = useState([]);
  const [location, setLocation] = useState([]);
  const [openBackdrop, setOpenBreakdrop] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [openSwitchModel, setOpenSwitchModel] = useState(false);
  const [notify, setNotify] = useState({});
  const [companyName, setCompanyName] = useState([]);
  const [companyId, setCompanyId] = useState([]);
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentImageIndex, setImageIndex] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [openmarginPopup, setOpenmarginPopup] = useState(false);
  const [buyerId, setbuyerId] = useState();
  const [deleteCompanyId, setDeleteCompanyId] = useState(null);
  const [deleteCompanyPopup, setDeleteCompanyPopup] = useState(false);

  const navigate = useNavigate();
  const { state } = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const handleSwitchModel = () => setOpenSwitchModel(true);
  const handleCloseSwitch = () => setOpenSwitchModel(false);
  const openMarginBox = () => setOpenmarginPopup(true);
  const closeMarginBox = () => setOpenmarginPopup(false);
  const handleClickOpen = (index) => { setImageIndex(index); setOpen(true); };
  const handleClose = () => setOpen(false);
  const handleDeleteCompanyPopup = (id) => { setDeleteCompanyId(id); setDeleteCompanyPopup(true); };
  const closeDeleteBox = () => setDeleteCompanyPopup(false);

  const refreshScreen = () => setRefresh(!refresh);

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } = useForm(initialValues);

  const getDetails = async () => {
    const res = await buyerDetails(state.buyer);
    if (res && res.status) {
      setSelectedCompany(res?.BuyerSelectedCompany);
      setBuyer(res?.data);
      setCompany(res?.data?.company);
      setCategory(res?.data?.category);
      setLocation(res.data.location);
      setValues({ ...values, userMarginType: res?.data?.userMarginType, userMargin: res?.data?.userMargin });
      refreshScreen();
    }
  };

  useEffect(() => { getDetails(state.buyer); }, [state]);

  const CompanyList = async () => {
    const res = await getCompany(state?.buyer);
    if (res.status === true) setCompanyName(res.data);
    else setCompanyName([]);
  };

  useEffect(() => { CompanyList(); }, []);

  const getSelectedItem = (data) => {
    if (data) {
      items.push({ companyName: data?.companyName });
      setItems([...items]);
      setCompanyId(data?.id);
    }
  };

  const handelMarginChange = async (e) => {
    try {
      if (!values.userMargin) return setNotify({ isOpen: true, message: "Please enter margin", type: "error" });
      if (!values.userMarginType) return setNotify({ isOpen: true, message: "Please select margin type", type: "error" });
      if (!/^[0-9]*\.?[0-9]*$/.test(values.userMargin)) return setNotify({ isOpen: true, message: "Please enter valid margin", type: "error" });

      setOpenBreakdrop(true);
      e.preventDefault();
      const res = await addUserMargin(buyerId, { userMargin: values.userMargin, userMarginType: values.userMarginType });
      if (res) {
        setOpenmarginPopup(false);
        setOpenBreakdrop(false);
        getDetails(buyerId);
        enqueueSnackbar("Margin updated successfully", { variant: "success", autoHideDuration: 2000 });
      } else {
        setOpenBreakdrop(false);
        setOpenmarginPopup(false);
        enqueueSnackbar("Something went wrong", { variant: "error", autoHideDuration: 2000 });
      }
    } catch (error) {
      setOpenBreakdrop(false);
    }
  };

  const EditHandler = (data) => {
    navigate(`/addcompany`, { state: { edit: true, data, buyer: state.buyer, companyId: data.id } });
  };

  const handleConfirmDelete = async () => {
    if (deleteCompanyId) {
      const deleteRes = await deleteCompany(deleteCompanyId, { buyerId: state.buyer });
      if (deleteRes && deleteRes.status) {
        getDetails();
        setDeleteCompanyPopup(false);
        setDeleteCompanyId(null);
        enqueueSnackbar(deleteRes.message || "Deleted successfully", { variant: "success", autoHideDuration: 2000 });
      } else {
        enqueueSnackbar(deleteRes.message || "Failed to delete company", { variant: "error", autoHideDuration: 2000 });
      }
    } else {
      enqueueSnackbar("Company not selected", { variant: "error", autoHideDuration: 2000 });
    }
  };

  const handleChangeStatus = async () => {
    setOpenBreakdrop(true);
    const res = await CompanyAssign({ userId: buyer?.id, companyId });
    if (res && res.status === true) {
      handleCloseSwitch();
      getDetails();
      setNotify({ isOpen: true, message: res.message || "Status changed Successfully.", type: "success" });
    } else {
      setOpenBreakdrop(false);
      setNotify({ isOpen: true, message: res.message || "Something went wrong.", type: "error" });
    }
  };

  const handleTaxStatus = async (e) => {
    const val = e.target.value;
    const res = await taxStatusChange(state.buyer, { taxSlab: val === "" ? 0 : val });
    if (res && res.status === true) {
      setBuyer((prev) => ({ ...prev, taxSlab: val }));
      enqueueSnackbar(res.message, { variant: "success", autoHideDuration: 2000 });
    }
  };

  return (
    <>
      <Box sx={{ minHeight: "100vh", backgroundColor: "#f1f5f9" }}>
        {/* Header */}
        <Box sx={{ backgroundColor: "#fff", borderBottom: "1px solid #e5e7eb", px: { xs: 2, md: 4 }, py: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2}>
            <Stack direction="row" alignItems="center" gap={1.5}>
              <IconButton
                onClick={() => navigate("/buyer")}
                sx={{ bgcolor: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: "10px", p: 0.8 }}
              >
                <KeyboardBackspaceIcon sx={{ fontSize: 20, color: "#374151" }} />
              </IconButton>
              <Box>
                <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>
                  Buyer Detail
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#6b7280" }}>
                  {selectedCompany?.companyId || "—"}
                </Typography>
              </Box>
            </Stack>
            <Stack direction="row" gap={1.5}>
              <Button
                variant="outlined"
                onClick={handleSwitchModel}
                sx={{
                  borderRadius: "10px", textTransform: "none", fontSize: "13px", fontWeight: 600,
                  borderColor: "rgb(79,70,229)", color: "rgb(79,70,229)",
                  "&:hover": { bgcolor: "rgba(79,70,229,0.05)", borderColor: "rgb(79,70,229)" },
                }}
              >
                Assign Company
              </Button>
              <Button
                variant="contained"
                startIcon={<EditIcon sx={{ fontSize: 16 }} />}
                onClick={() => navigate("/buyerEdit", { state: { buyer: state?.buyer, companyId: state?.companyId } })}
                sx={{
                  borderRadius: "10px", textTransform: "none", fontSize: "13px", fontWeight: 600,
                  bgcolor: "rgb(79,70,229)", boxShadow: "none",
                  "&:hover": { bgcolor: "rgb(67,56,202)", boxShadow: "none" },
                }}
              >
                Edit Buyer
              </Button>
            </Stack>
          </Stack>
        </Box>

        {/* Content */}
        <Box sx={{ px: { xs: 2, md: 4 }, py: 3, maxWidth: "1100px", mx: "auto" }}>
          {/* Personal Details */}
          <SectionCard icon={<PersonOutlineIcon />} title="Personal Details">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <InfoField label="User Name" value={buyer?.userName} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InfoField label="Email" value={buyer?.email} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InfoField label="Phone Number" value={buyer?.mobile} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box>
                  <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", mb: 0.5 }}>
                    TDS / TCS
                  </Typography>
                  <Controls.SelectBox
                    className="input"
                    id="taxSlab"
                    value={buyer?.taxSlab == 0 ? "" : parseInt(buyer?.taxSlab)}
                    onChange={handleTaxStatus}
                    color="primary"
                    options={tdsList}
                    label="None"
                    sx={{ minWidth: 160 }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box>
                  <Stack direction="row" alignItems="center" gap={0.5} mb={0.5}>
                    <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                      Margin
                    </Typography>
                    {!openmarginPopup && (
                      <IconButton
                        size="small"
                        onClick={() => { setbuyerId(buyer.id); openMarginBox(); }}
                        sx={{ p: 0.3, color: "rgb(79,70,229)" }}
                      >
                        <EditIcon sx={{ fontSize: 14 }} />
                      </IconButton>
                    )}
                  </Stack>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#111827" }}>
                    {buyer?.userMarginType == 1 ? "+" : buyer?.userMarginType == 0 ? "-" : ""}
                    {buyer?.userMargin || "—"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </SectionCard>

          {/* Company Details */}
          {company?.map((row, index) => (
            <SectionCard
              key={row.id || index}
              icon={<BusinessIcon />}
              title={`Company Detail${company.length > 1 ? ` #${index + 1}` : ""}`}
              action={
                <Stack direction="row" gap={1}>
                  <IconButton
                    size="small"
                    onClick={() => EditHandler(row)}
                    sx={{ bgcolor: "rgba(79,70,229,0.08)", borderRadius: "8px", p: 0.8, "&:hover": { bgcolor: "rgba(79,70,229,0.15)" } }}
                  >
                    <EditIcon sx={{ fontSize: 16, color: "rgb(79,70,229)" }} />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteCompanyPopup(row.id)}
                    sx={{ bgcolor: "rgba(239,68,68,0.08)", borderRadius: "8px", p: 0.8, "&:hover": { bgcolor: "rgba(239,68,68,0.15)" } }}
                  >
                    <DeleteIcon sx={{ fontSize: 16, color: "#ef4444" }} />
                  </IconButton>
                </Stack>
              }
            >
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <InfoField label="Company Name" value={row?.companyName} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InfoField label="Address" value={row?.address} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InfoField label="GST Number" value={row?.gstNumber} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InfoField label="PAN Number" value={row?.panNumber} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InfoField label="State" value={row?.stateName} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InfoField label="City" value={row?.cityName} />
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                  <Stack direction="row" gap={3} mt={2} flexWrap="wrap">
                    <Box>
                      <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", mb: 1 }}>
                        PAN Image
                      </Typography>
                      <Box
                        component="img"
                        src={row?.panImage}
                        alt="PAN"
                        onClick={() => handleClickOpen(index)}
                        sx={{
                          width: 120, height: 80, objectFit: "cover", borderRadius: "10px",
                          border: "1px solid #e5e7eb", cursor: "pointer",
                          "&:hover": { opacity: 0.85 },
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: "11px", fontWeight: 600, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", mb: 1 }}>
                        GST Certificate
                      </Typography>
                      <a href={row?.gstCertificate} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                        <Button
                          variant="outlined"
                          startIcon={<PictureAsPdfIcon />}
                          sx={{
                            borderRadius: "10px", textTransform: "none", fontSize: "13px",
                            borderColor: "#e5e7eb", color: "#374151",
                            "&:hover": { borderColor: "rgb(79,70,229)", color: "rgb(79,70,229)", bgcolor: "rgba(79,70,229,0.04)" },
                          }}
                        >
                          View PDF
                        </Button>
                      </a>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </SectionCard>
          ))}

          {/* Location & Category */}
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SectionCard icon={<LocationOnOutlinedIcon />} title="Locations">
                <TableContainer sx={{ borderRadius: "10px", border: "1px solid #e5e7eb", backgroundColor: "#fff" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                        {["State", "City"].map((h) => (
                          <TableCell key={h} sx={{ fontSize: "12px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", borderColor: "#f0f0f0" }}>
                            {h}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {location?.map((row, i) => (
                        <TableRow key={i} sx={{ "&:last-child td": { border: 0 } }}>
                          <TableCell sx={{ fontSize: "13px", color: "#374151", borderColor: "#f8fafc" }}>{row.stateName}</TableCell>
                          <TableCell sx={{ fontSize: "13px", color: "#374151", borderColor: "#f8fafc" }}>{row.cityName}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </SectionCard>
            </Grid>
            <Grid item xs={12} md={6}>
              <SectionCard icon={<CategoryOutlinedIcon />} title="Categories">
                <Stack direction="row" flexWrap="wrap" gap={1}>
                  {category?.map((row, i) => (
                    <Chip
                      key={i}
                      label={row?.name}
                      sx={{
                        bgcolor: "rgba(79,70,229,0.08)", color: "rgb(79,70,229)",
                        fontWeight: 600, fontSize: "12px", borderRadius: "8px",
                      }}
                    />
                  ))}
                </Stack>
              </SectionCard>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* PAN Image Dialog */}
      <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleClose}>
        <DialogContent sx={{ p: 2 }}>
          <img width="100%" src={company[currentImageIndex]?.panImage} alt="" style={{ borderRadius: "8px" }} />
        </DialogContent>
      </Dialog>

      {/* Assign Company Modal */}
      <Modal open={openSwitchModel} onClose={handleCloseSwitch}>
        <Box sx={modalStyle}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827" }}>Assign Company</Typography>
            <IconButton onClick={handleCloseSwitch} size="small"><CloseIcon /></IconButton>
          </Stack>
          <Controls.Button
            text="Create Company"
            sx={{ width: "100%", borderRadius: "10px", textTransform: "none", bgcolor: "rgb(79,70,229)", "&:hover": { bgcolor: "rgb(67,56,202)" } }}
            onClick={() => navigate("/addcompany", { state: { buyer: state.buyer, companyId: "", edit: false, data: null } })}
          />
          <Divider sx={{ my: 2 }}>OR</Divider>
          <Autocomplete
            disablePortal selectOnFocus clearOnBlur handleHomeEndKeys openOnFocus
            options={companyName}
            onChange={(event, value) => getSelectedItem(value)}
            getOptionLabel={(option) => option ? option.companyName : ""}
            sx={{ "& .MuiAutocomplete-popupIndicator": { transform: "none" } }}
            renderInput={(params) => <Controls.Input fullWidth {...params} label="Search company" />}
            popupIcon={<Search />}
          />
          <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
            <Button onClick={handleCloseSwitch} sx={{ borderRadius: "10px", textTransform: "none", color: "#6b7280" }}>Cancel</Button>
            <Button variant="contained" onClick={() => handleChangeStatus()} sx={{ borderRadius: "10px", textTransform: "none", bgcolor: "rgb(79,70,229)", boxShadow: "none", "&:hover": { bgcolor: "rgb(67,56,202)", boxShadow: "none" } }}>Submit</Button>
          </Stack>
        </Box>
      </Modal>

      {/* Margin Modal */}
      <Modal open={openmarginPopup} onClose={closeMarginBox}>
        <Box sx={modalStyle}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827" }}>Edit Margin</Typography>
            <IconButton onClick={closeMarginBox} size="small"><CloseIcon /></IconButton>
          </Stack>
          <Stack direction="row" gap={1} mt={1}>
            <select
              style={{ width: "90px", height: "40px", borderRadius: "8px", border: "1px solid #e5e7eb", padding: "5px 8px", outline: "none", fontSize: "14px" }}
              name="userMarginType"
              value={values.userMarginType}
              onChange={handleInputChange}
            >
              <option value="">Type</option>
              <option value="0">−</option>
              <option value="1">+</option>
            </select>
            <Controls.Input
              variant="outlined"
              label="Margin"
              name="userMargin"
              value={values.userMargin}
              onChange={handleInputChange}
              error={errors.userMargin}
              helperText={errors.userMargin}
              fullWidth
            />
          </Stack>
          <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
            <Button onClick={closeMarginBox} sx={{ borderRadius: "10px", textTransform: "none", color: "#6b7280" }}>Cancel</Button>
            <Button variant="contained" onClick={handelMarginChange} sx={{ borderRadius: "10px", textTransform: "none", bgcolor: "rgb(79,70,229)", boxShadow: "none", "&:hover": { bgcolor: "rgb(67,56,202)", boxShadow: "none" } }}>Save</Button>
          </Stack>
        </Box>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal open={deleteCompanyPopup} onClose={closeDeleteBox}>
        <Box sx={modalStyle}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827" }}>Delete Company</Typography>
            <IconButton onClick={closeDeleteBox} size="small"><CloseIcon /></IconButton>
          </Stack>
          <Typography sx={{ fontSize: "14px", color: "#6b7280", mb: 3 }}>
            Are you sure you want to delete this company? This action cannot be undone.
          </Typography>
          <Stack direction="row" justifyContent="flex-end" gap={1}>
            <Button onClick={closeDeleteBox} sx={{ borderRadius: "10px", textTransform: "none", color: "#6b7280" }}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleConfirmDelete}
              sx={{ borderRadius: "10px", textTransform: "none", bgcolor: "#ef4444", boxShadow: "none", "&:hover": { bgcolor: "#dc2626", boxShadow: "none" } }}
            >
              Delete
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default BuyerDetail;
